export const DISCOUNTS_TEXT = 'Discounts'

export const ICON_WIDTH = '16px'
